"use client";
import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ImageCarousel from "@/components/carousel";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Image from "next/image";

const blogPosts = [
  {
    title: "Top 5 Cruise Destinations You Need to Visit",
    date: "04 Jun, 2025",
    image: IMAGES.cruiseDestination,
  },
  {
    title: "Essential Travel Tips for First-Time Flyers",
    date: "04 Jun, 2025",
    image: IMAGES.blogTravel,
  },
  {
    title: "How to Handle Travel Anxiety: Tips for a Stress-Free Trip",
    date: "04 Jun, 2025",
    image: IMAGES.mentalIllness,
  },
];

const BlogCarouselComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box sx={{ p:{ xs: 2, md: 8 }}}>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flexDirection: { xs: "row" },
          justifyContent: {
            xs: "space-between",
          },
          mb: 4,
        }}
      >
        <Box display={"flex"}>
          <Box
            width={10}
            sx={{
              background: "linear-gradient(to bottom, #00F200, #ffffff)", // Gradient from top to bottom
              borderRadius: "10px 10px 0 0", // Rounded top corners
              height: {
                md: 150,
                xs: 100,
              },
            }}
          ></Box>

          <Box px={2}>
            <Typography
              color={WEB_COLORS.darkTeal}
              sx={{
                fontSize: {
                  xs: 20,
                  md: 40,
                },
                textTransform: {
                  md: "capitalize",
                },
              }}
            >
              Personal loans related blogs
            </Typography>
          </Box>
        </Box>
      </Grid>

      {isMobile && (
        <ImageCarousel
          images={blogPosts.map((val) => val.image)}
          controllerEnabled={false}
        />
      )}
      {!isMobile && (
        <Box
          sx={{ position: "relative", display: "flex", alignItems: "center" }}
        >
          <Box
            sx={{
              display: "flex",
              overflow: "hidden",
              width: "100%",
              justifyContent: "center",
              gap: 2,
            }}
          >
            {blogPosts.map((post, index) => (
              <Card
                key={index}
                sx={{
                  minWidth: 280,
                  maxWidth: 300,
                  boxShadow: 3,
                }}
              >
                <Image src={post.image} alt={post.title} />
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {post.title}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {post.date}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      )}

      {/* View All Button */}
      <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: WEB_COLORS.darkTeal,
            "&:hover": { backgroundColor: "#003024" },
          }}
          fullWidth={isMobile}
        >
          <Typography color={"#fff"} textTransform={"none"}>
            View All
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default BlogCarouselComponent;
